<template>
  <div class="course-details">
    <div class="container">
      <div class="header">
        <h4>تفاصيل الكورس</h4>
      </div>

      <CourseHeader 
        :course="course" 
        :isModalOpen="isSubscriptionModalOpen" 
        :selectedCourseId="selectedCourseId"
        :isEnrolled="isEnrolled"
        @open-modal="openSubscriptionModal"
        @close-modal="closeSubscriptionModal"
        @subscription-successful="handleSubscriptionSuccess"
      />

      <div class="content">
        <div class="chapters">
          <div 
            v-for="(lesson, index) in course.lessons" 
            :key="lesson.id" 
            class="chapter"
          >
            <div class="chapter-header" @click="toggleChapter(index, lesson.id)">
              <div class="title">{{ lesson.name }}</div>
              <div class="icon">
                <i :class="openChapter === index ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
              </div>
            </div>

            <div v-if="openChapter === index" class="chapter-lessons">
              <ul class="chapter-list">
                <li 
                  v-for="video in lesson.videos" 
                  :key="video.id" 
                  class="video-item"
                  :class="{ 'locked': video.locked }"
                >
                  <div class="video-info" @click="openVideoModal(video)">
                    <i class="bi bi-play-circle fs-2"></i>
                    <img 
                      v-if="video.image" 
                      :src="video.image.original_url" 
                      alt="video thumbnail" 
                      width="50"
                      class="rounded"
                    />
                    <i v-if="video.locked" class="bi bi-lock-fill lock-icon"></i>
                    <span class="fs-5">{{ video.title }}</span>
                  </div>
                  <div class="item-meta">
                    <div class="lesson-labels">
                      <routerLink to="/homework" class="main homework" :class="{ disabled: !isEnrolled }">
                        <i class="bi bi-calendar-plus-fill"></i>
                        <p>الواجبات</p>
                      </routerLink>
                      <routerLink to="/exams" class="main exams" :class="{ disabled: !isEnrolled }">
                        <i class="bi bi-calendar2-range-fill"></i>
                        <p>الإمتحانات</p>
                      </routerLink>
                      <a 
                        :href="video.pdf ? video.pdf.original_url : '#'" 
                        class="main pdf" 
                        :class="{ disabled: !isEnrolled }"
                        :download="video.pdf ? video.pdf.file_name : null"
                        target="_blank"
                      >
                        <i class="bi bi-file-earmark-pdf-fill"></i>
                        <p>PDF</p>
                      </a>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      <VideoModal 
        v-if="isVideoModalOpen"
        :videoUrl="selectedVideoUrl"
        @close="closeVideoModal"
        @video-unlocked="handleVideoUnlocked"
      />
    </div>
  </div>
</template>

<script>
import CourseHeader from './CourseHeader.vue';
import VideoModal from './VideoModal.vue';
import apiService from "@/apiService";

export default {
  components: { CourseHeader, VideoModal },

  data() {
    return {
      course: { lessons: [] },
      openChapter: null,
      isSubscriptionModalOpen: false,
      isVideoModalOpen: false,
      selectedCourseId: null,
      subscriptionStatus: "",
      selectedVideoUrl: "",
      selectedVideoDbId: null,
    };
  },

  computed: {
    isEnrolled() {
      return this.subscriptionStatus === "مشترك بالفعل" || this.subscriptionStatus === "مجاني";
    }
  },

  created() {
    this.getCourseDetails();
  },

  methods: {
async getCourseDetails() {
  try {
    const lessonsResponse = await apiService.getLessons(this.$route.params.id);
    const lessonsData = lessonsResponse.data.data || lessonsResponse.data;
    console.log("Lessons Data:", lessonsData);
    const firstLesson = Array.isArray(lessonsData) ? lessonsData[0] : lessonsData;

    const coursesResponse = await apiService.getCourses();
    const courses = coursesResponse.data.data;
    const selectedCourse = courses.find(c => c.id == this.$route.params.id);


    this.course = {
      id: firstLesson.id,
      course_name: firstLesson.course_name,
      course_image: firstLesson.course_image,
      course_price: firstLesson.course_price,
      course_description: firstLesson.course_description,
      lessons: Array.isArray(lessonsData) ? lessonsData : [lessonsData],
      subscription_status: selectedCourse ? selectedCourse.subscription_status : "غير مشترك"
    };
    this.subscriptionStatus = this.course.subscription_status;

  } catch (error) {
    console.error("Error fetching course details:", error);
  }
},

    toggleChapter(index, lessonId) {
      this.openChapter = this.openChapter === index ? null : index;
      if (this.openChapter === index) {
        this.getVideos(lessonId);
      }
    },

    handleSubscriptionSuccess() {
      this.subscriptionStatus = "مشترك بالفعل";
      if (this.course) {
        this.course.subscription_status = "مشترك بالفعل";
      }
      this.closeSubscriptionModal();
    },

    openSubscriptionModal(courseId) {
      this.isSubscriptionModalOpen = true;
      this.selectedCourseId = courseId;
    },

    closeSubscriptionModal() {
      this.isSubscriptionModalOpen = false;
      this.selectedCourseId = null;
    },

    async getVideos(lessonId) {
      try {
        const response = await apiService.getVideos(lessonId);
        
        if (response.data && response.data.data) {
          const lesson = this.course.lessons.find(l => l.id === lessonId);
          if (lesson) {
            lesson.videos = response.data.data;
          }
        }
      } catch (error) {
        console.error("Error fetching videos:", error);
      }
    },

    formatBunnyLink(link) {
      const idMatch = link.match(/\/play\/(\d+)\/([\w-]+)/);
      if (idMatch) {
        const [, libraryId, videoId] = idMatch;
        return `https://iframe.mediadelivery.net/embed/${libraryId}/${videoId}?autoplay=true`;
      }
      return link;
    },

    openVideoModal(video) {
      if (video.locked) {
        alert("هذا الفيديو مقفل. " + (video.lock_reason === 'sequence' ? "يجب عليك مشاهدة الفيديو السابق أولاً!" : ""));
        return;
      }
      
      if (this.isEnrolled) {
        this.selectedVideoUrl = this.formatBunnyLink(video.link);
        this.selectedVideoDbId = video.id;
        this.isVideoModalOpen = true;
      } else {
        this.openSubscriptionModal(this.course.id);
      }
    },

    closeVideoModal() {
      this.isVideoModalOpen = false;
      this.selectedVideoUrl = null;
      this.selectedVideoDbId = null;
    },
    
    async handleVideoUnlocked(videoUrl) {
      try {
        const videoId = this.selectedVideoDbId;
        if (videoId) {
          await apiService.markVideoAsWatched(videoId);
          
          const currentLessonId = this.course.lessons[this.openChapter].id;
          await this.getVideos(currentLessonId);
        }
      } catch (error) {
        console.error("Error handling video progress:", error);
      }
    },
    
  }
};

</script>



<style scoped>
.course-details {
  background: #f8f8f8;
  padding-top: 200px;
  min-height: 100vh;
  text-align: right;
}
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 48px;
}
/* breadcrumb */
.breadcrumb {
    display: flex;
    align-items: center;
    gap: 8px;
  font-size: 16px;
  margin-bottom: 15px;
  color: #666;
  font-weight: 500;
}
.breadcrumb .link {
  cursor: pointer;
  color: #7F8685;
}
.breadcrumb .link:hover {
  text-decoration: underline;
}
.breadcrumb .current {
  font-weight: bold;
  color: #333;
}

.chapter {
  border-radius: 24px;
  overflow: hidden;
}

.chapter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  background: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s ease;
}
.chapter-header .title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 22px;
  font-weight: 400;
  margin: 0;
}
.chapter-header .icon {
  background-color: rgba(255, 154, 24, 0.2);
  color: #FF9A18;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  line-height: 38px;
}
.chapter-header .icon i {
  font-size: 25px;
}
.chapter-header .title i {
  font-size: 25px;
}
.chapter-lessons {
  background: #fff;
  padding: 12px 16px;
}

.lesson {
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.lesson:last-child {
  border-bottom: none;
}

.actions {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.btn {
  padding: 6px 12px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 14px;
}
.locked {
  margin-top: 8px;
  color: #888;
}

.accordion-enter-active,
.accordion-leave-active {
  transition: all 0.3s ease;
}
.accordion-enter-from,
.accordion-leave-to {
  max-height: 0;
  opacity: 0;
}
.accordion-enter-to,
.accordion-leave-from {
  max-height: 1000px;
  opacity: 1;
}
.content {
  padding: 48px 0;
}
.content h3{
  padding-bottom: 32px;
  font-size: 26px;
  font-weight: 600;
}
.chapters{
    display: flex;
  flex-direction: column;
  gap: 32px;
}
.lesson-title {
  font-weight: 600;
  font-size: 16px;
  margin: 12px 0;
  display: flex;
  justify-content: space-between;
  color: #333;
}

.chapter-list {
  list-style: none;
  margin: 0;
  padding: 0;
      display: flex;
    flex-direction: column;
    gap: 15px;
}

.chapter-item {
  display: flex;
  justify-content: space-between;

  padding: 12px 0;
  border-bottom: 1px solid #DEE1E3;
}

.chapter-item:last-child {
  border-bottom: none;
}
.chapter_detials_item {
  display: flex;
  align-items: center;
  gap: 24px;
  color: #000;
}
.chapter-item img {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  object-fit: cover;
}

.chapter-item p {
  margin: 0;
  font-weight: 500;
  color: #222;
  flex: 1;

}

.lesson-labels {
  display: flex;
  align-items: center;
  gap: 15px;
  font-size: 14px;

}
.btn-subscribe:disabled {
  background: #fff;
  cursor: not-allowed;
  opacity: 0.7;
}
.lesson-label {
  padding: 10px;
  border-radius: 24px;
  border: 1px solid #ddd;
}
.chapter_detials img {
  width: 85px;
  height: 48px;
}
.lesson-labels span{
  display: flex;
  align-items: center;
  gap: 8px;
  
}
.lesson-labels .main {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px;
  border-radius: 24px;
}
.lesson-labels .main.homework {
  color: #FF7700;
  border: 1px solid #FF7700;
}
.lesson-labels .main.main.homework p {
  color: #FF7700;
  font-weight: 500;
}
.lesson-labels .main.main.exams p {
  color: #15C01B;
  font-weight: 500;
}
.lesson-labels .main.main.pdf p {
  color: #FF494C;
  font-weight: 500;
}
.lesson-labels .main.exams {
  color: #15C01B;
  border: 1px solid #15C01B;
}
.lesson-labels .main.pdf {
  color: #FF494C;
  border: 1px solid #FF494C;
}
.chapter-lessons.disabled {
  color: #7F8685 !important;
  cursor: not-allowed;
  pointer-events: none;
}
.lesson-labels .main.disabled{
    color: #7F8685 !important;
  cursor: not-allowed;
  pointer-events: none;
  border: 1px solid #7F8685 !important;

}
.lesson-labels .main p {
  margin: 0;
}
.lesson-labels .main.disabled p {
  color: #7F8685 !important;
}
@media (max-width: 948px) {
  .course-header {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .course-header img {
    margin-bottom: 20px;
  }
  .info .title {
    flex-direction: column;
    gap: 10px;
  }
  .course-info {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  .items {
    justify-content: center;
    flex-direction: column;
  }
}
@media screen and (max-width: 768px) {
  .chapter-item {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .chapter-item img {
    margin-bottom: 12px;
  }
  .chapter-header .title {
    font-size: 15px !important;
  }
  .header {
    flex-direction: column;
  }
  .video-item {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
}
.video-item {
    display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
}
.video-item.locked {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: not-allowed;
  opacity: 0.5;
}
.video-item.locked:hover {
  background-color: #f1f1f1;
  transform: none;
}
.video-info {
  display: flex;
  align-items: center;
  gap: 15px;
  cursor: pointer;
}
.lock-icon {
  left: 15px; 
  font-size: 20px;
  color: #888;
  z-index: 10;
}
</style>
